import React, {useEffect, useRef, useState} from 'react';
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import * as Iconly from "react-iconly";
import {imageToBase64} from "../utils/functions";
import {types, useUser} from "../auth/UserContext";
import {useAuth, useEntityObject} from "../dynamic365";
import PortalUser from "../dynamic365/entities/PortalUser";
import Contact from "../dynamic365/entities/Contact";
import {useStorage} from "../hooks/useStorage";
import {Button} from "primereact/button";
import {Password} from "primereact/password";
import {sha1} from "js-sha1";

function CustomHeader({title, setVisible}) {
    return(
        <div className="flex justify-content-between align-items-center p-3 pb-0">
            <span className="pi pi-times cursor-pointer" onClick={()=>{setVisible(false)}}/>
            <span>{title}</span>
        </div>
    )
}

function UserProfileDialog({visible, setVisible, title}) {
    const user = useUser();
    const auth = useAuth();
    const{setUser} = useStorage();
    const hiddenFileInput = useRef();
    const [filename, setFileName] = useState();
    const [documentBody, setDocumentBody] = useState();
    const portalUserEntity = useEntityObject(PortalUser());
    const contactEntity = useEntityObject(Contact());
    const [oldPassword, setOldPassword] = useState();
    const [newPassword, setNewPassword] = useState();
    const [confirmPassword, setConfirmPassword] = useState();
    const [loading, setLoading] = useState(false);
    const [changePasswordResult, setChangePasswordResult] = useState();


    const uploadImage = (b64)=>{
        contactEntity.update({
            onResult:(data)=>{
                contactEntity.fetch({
                    onResult:({data:{value}})=>{
                        // console.log(value[0])
                        let userData = {...user.state.userData, ...value[0]};
                        setUser(userData);
                        user.dispatch({type:types.SET_USER_DATA, userData})
                    },
                    onError:()=>{},
                    filters:{contactid:"$contactId"}

                })
            },
            onError:()=>{},
            id:user.state.userData.contactid,
            body:{
                entityimage:b64
            }
        })
    }

    const updatePassword = ()=>{
        setLoading(true)
        auth.update_password({
            onResult:(data)=>{
                setLoading(false)
                setChangePasswordResult(data)
                // console.log(data)
            },
            onError:(e)=>{
                setLoading(false)
                // console.log(e)
            },
            bodyData:{
                currentPassword : sha1(oldPassword),
                newPassword : sha1(newPassword),
                confirmNewPassword : sha1(confirmPassword)
            },
            token:user.state.userData.token,
        })
    }

    return (
        <Dialog visible={visible} onHide={()=>{setVisible(false)}} className="w-10 lg:w-6" contentClassName="p-0 border-round-2xl" closeOnEscape={true} showHeader={false}>
            <>
                <CustomHeader setVisible={setVisible} title={title}/>
                <div className="flex flex-column gap-2 p-3 h-full align-items-end">
                    <div className="border-1 w-12rem h-12rem border-gray-300 border-round align-items-center flex justify-content-center">
                        {
                            user.state.userData.entityimage ?(
                                <img className="h-full border-round border-1 border-primary" src={`data:image/jpeg;base64,${user.state.userData.entityimage}`}/>
                            ):(

                                <div className="w-12rem h-12rem flex justify-content-center align-items-center">
                                    <input ref={hiddenFileInput} className="p-hidden" type="file" onChange={(e)=>{const file = e.target.files[0]; setFileName(e.target.files[0] && e.target.files[0].name) ;imageToBase64(file, (b64)=>{setDocumentBody(b64); uploadImage(b64)});}}/>
                                    <span className="cursor-pointer" onClick={()=>{hiddenFileInput.current.click()}}>
                                            {
                                                documentBody?(
                                                    <img className="w-full h-auto border-round border-1 border-primary" src={`data:image/jpeg;base64,${documentBody}`}/>
                                                ):(
                                                    <Iconly.Download filled primaryColor="#bbb" size="large"/>
                                                )
                                            }
                                        </span>
                                </div>
                            )
                        }
                    </div>
                    <div className="grid grid-nogutter w-full rtl">
                        <div className="col-6 p-2">
                            <small>نام</small>
                            <InputText value={user.state.userData.firstname} disabled className="w-full"/>
                        </div>
                        <div className="col-6 p-2">
                            <small>نام خانوادگی</small>
                            <InputText value={user.state.userData.lastname} disabled className="w-full"/>
                        </div>
                        <div className="col-6 p-2">
                            <small>شماره موبایل</small>
                            <InputText value={user.state.userData.phoneNumber} disabled className="w-full"/>
                        </div>
                        <div className="col-6 p-2">
                            <small>ایمیل</small>
                            <InputText value={user.state.userData.email} disabled className="w-full"/>
                        </div>
                    </div>
                    <span className="font-bold p-2">تغییر رمز</span>
                    <div className="w-6 w-full rtl">
                        <div className="p-2">
                            <small>رمز قبلی</small>
                            <Password feedback={false} value={oldPassword} onChange={(e)=>{setOldPassword(e.target.value)}} toggleMask className="w-full" inputClassName={`text-center w-full border-round-xl bg-gray-100 shadow-none border-none`}/>
                        </div>
                        <div className="p-2">
                            <small>رمز جدید</small>
                            <Password feedback={false} value={newPassword} onChange={(e)=>{setNewPassword(e.target.value);}} toggleMask className="w-full" inputClassName={`text-center w-full border-round-xl bg-gray-100 shadow-none border-none`}/>
                        </div>
                        <div className="p-2">
                            <small>تکرار رمز جدید</small>
                            <Password feedback={false} value={confirmPassword} onChange={(e)=>{setConfirmPassword(e.target.value);}} toggleMask className="w-full" inputClassName={`text-center w-full border-round-xl bg-gray-100 shadow-none border-none`}/>
                        </div>
                        <div className="p-2">
                            <Button loading={loading} className="p-button-sm" label="تغییر رمز" onClick={()=>{updatePassword()}}/>
                        </div>
                        {
                            changePasswordResult && (
                                <div className="p-2">
                                    <span className={`${changePasswordResult.isSuccess?"text-green-500":"text-red-500"}`}>{changePasswordResult.message}</span>
                                </div>
                            )
                        }
                    </div>
                </div>
            </>
        </Dialog>
    );
}

export default UserProfileDialog;